export default __webpack_public_path__ + "static/media/calendar-icon.ee1ebb08.svg";